module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article"
  }, [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb1)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb1, 'hb1')
      }
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d038581","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Article/Template/index.vue
// module id = 126
// module chunks = 2